var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6267",
    "data-name": "Group 6267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.524,
    height: 18.524,
    viewBox: "0 0 18.524 18.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2386",
    "data-name": "Rectangle 2386",
    width: 18.524,
    height: 18.524,
    fill: "#fcbf49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6266",
    "data-name": "Group 6266",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16265",
    "data-name": "Path 16265",
    d: "M9.262,1.669c2.473,0,2.766.009,3.743.054a5.125,5.125,0,0,1,1.72.319,2.869,2.869,0,0,1,1.065.693A2.871,2.871,0,0,1,16.483,3.8a5.126,5.126,0,0,1,.319,1.72c.045.977.054,1.27.054,3.743S16.846,12.028,16.8,13a5.126,5.126,0,0,1-.319,1.72,3.067,3.067,0,0,1-1.758,1.758A5.125,5.125,0,0,1,13,16.8c-.976.045-1.269.054-3.743.054S6.5,16.846,5.519,16.8a5.125,5.125,0,0,1-1.72-.319,2.87,2.87,0,0,1-1.065-.693,2.87,2.87,0,0,1-.693-1.065A5.126,5.126,0,0,1,1.723,13c-.045-.977-.054-1.27-.054-3.743s.009-2.766.054-3.743A5.126,5.126,0,0,1,2.042,3.8a2.87,2.87,0,0,1,.693-1.065A2.869,2.869,0,0,1,3.8,2.042a5.125,5.125,0,0,1,1.72-.319c.977-.045,1.27-.054,3.743-.054M9.262,0C6.747,0,6.431.011,5.443.056A6.8,6.8,0,0,0,3.2.486,4.541,4.541,0,0,0,1.555,1.555,4.54,4.54,0,0,0,.486,3.2,6.8,6.8,0,0,0,.056,5.443C.011,6.431,0,6.747,0,9.262s.011,2.831.056,3.819a6.8,6.8,0,0,0,.431,2.248A4.54,4.54,0,0,0,1.555,16.97,4.541,4.541,0,0,0,3.2,18.038a6.8,6.8,0,0,0,2.248.431c.988.045,1.3.056,3.819.056s2.831-.011,3.819-.056a6.8,6.8,0,0,0,2.248-.431,4.736,4.736,0,0,0,2.709-2.709,6.8,6.8,0,0,0,.431-2.248c.045-.988.056-1.3.056-3.819s-.011-2.831-.056-3.819A6.8,6.8,0,0,0,18.038,3.2,4.54,4.54,0,0,0,16.97,1.555,4.541,4.541,0,0,0,15.329.486,6.8,6.8,0,0,0,13.081.056C12.093.011,11.778,0,9.262,0",
    transform: "translate(0 0)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16266",
    "data-name": "Path 16266",
    d: "M108.616,103.861a4.756,4.756,0,1,0,4.756,4.756,4.756,4.756,0,0,0-4.756-4.756m0,7.844a3.087,3.087,0,1,1,3.087-3.087,3.087,3.087,0,0,1-3.087,3.087",
    transform: "translate(-99.354 -99.355)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16267",
    "data-name": "Path 16267",
    d: "M304.057,75.022a1.111,1.111,0,1,1-1.111-1.111,1.111,1.111,0,0,1,1.111,1.111",
    transform: "translate(-288.739 -70.704)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4fb3520b794b736dfa08a55000ac8bbd.svg";
export { ForwardRef as ReactComponent };